import React from 'react';

const HousebetsLogoIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "158",
    height: "21",
    viewBox: "0 0 158 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M21.8615 0.5V20.5H14.3038V14.1731C14.3038 13.1788 13.8111 12.249 12.9883 11.6907L12.3565 11.262C11.6785 10.8019 10.7885 10.8019 10.1105 11.262L9.47872 11.6907C8.65589 12.249 8.16317 13.1788 8.16317 14.1731V20.5H0.605469V0.503084H8.16317V7.9277H14.3038V0.5H21.8615Z",
      fill: "#4FE2FF"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M23.5703 13.5925C23.5703 22.7925 40.3201 22.7925 40.3201 13.5925C40.3201 4.3658 23.5703 4.3658 23.5703 13.5925ZM29.8054 13.5925C29.8054 10.5525 34.085 10.5525 34.085 13.5925C34.085 16.6058 29.8054 16.6058 29.8054 13.5925Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M53.3952 19.8858H58.2416V6.73913H52.0065V12.4458C52.0065 16.8191 47.7553 16.3125 47.9253 13.4858V6.73913H41.6902C41.6902 9.19246 41.6902 10.7658 41.6902 13.2191C41.6619 20.3658 50.3627 22.1791 53.0268 17.4858H52.9984C53.0834 17.4058 53.1968 17.3525 53.3102 17.3791C53.4235 17.4058 53.5086 17.5125 53.4802 17.6191L53.3952 19.8858Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M67.6981 15.3791H60.301V19.9125H69.852C72.4878 19.9125 74.9251 18.2058 74.9251 15.8058C74.9251 12.6591 69.852 12.4725 67.4713 12.1791C66.6778 12.0725 66.6494 11.3258 67.4997 11.3258H74.9251V6.7658H65.3457C62.71 6.7658 60.301 8.49913 60.301 10.8991C60.301 14.0458 65.3457 14.2325 67.7264 14.5258C68.52 14.6325 68.5483 15.3791 67.6981 15.3791Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M83.8969 16.3925C82.99 16.2858 82.9333 15.2725 83.8969 15.2991C95.8854 16.5525 96.2821 6.39246 84.6055 6.6858C73.8074 6.95246 72.5604 20.5791 86.1359 20.4991C88.4599 20.4991 90.7839 20.0725 92.3994 19.6991V15.5125C89.6219 16.4991 86.6744 16.6858 83.8969 16.3925ZM82.5932 11.9925C82.5649 10.3658 86.8444 9.9658 86.9011 11.6458C86.9295 13.1125 82.6216 13.0591 82.5932 11.9925Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M100.878 7.4058C100.481 7.61913 98.894 8.6058 98.6106 8.7658C97.8453 9.29913 97.0518 8.31246 98.1287 7.69913C98.2705 7.61913 99.8576 6.65913 99.9993 6.57913C101.105 5.8058 101.671 4.73913 101.671 3.75246V1.29913C99.4324 1.29913 97.1935 1.29913 94.9545 1.29913C94.9545 7.51246 94.9545 13.7258 94.9545 19.9658H101.161V18.1791C101.161 18.0725 101.246 17.9658 101.36 17.9391C101.473 17.9125 101.586 17.9658 101.643 18.0725C104.279 22.5525 111.534 20.0458 111.534 13.1925C111.534 8.0458 105.639 4.81913 100.878 7.4058ZM105.271 13.2725C105.016 16.9791 101.161 16.1525 101.19 13.4058V12.8458C101.19 10.3925 105.469 10.3925 105.271 13.2725Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M120.231 16.3925C119.325 16.2858 119.268 15.2725 120.231 15.2991C132.22 16.5525 132.617 6.39246 120.94 6.6858C110.142 6.95246 108.895 20.5791 122.47 20.4991C124.794 20.4991 127.118 20.0725 128.734 19.6991V15.5125C125.956 16.4991 123.009 16.6858 120.231 16.3925ZM118.928 11.9925C118.899 10.3658 123.179 9.9658 123.236 11.6458C123.264 13.1125 118.956 13.0591 118.928 11.9925Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M137.212 6.7658V1.27246H130.977C130.977 6.07246 130.977 8.95246 130.977 12.1525V13.2725C130.977 13.6725 130.977 14.0458 131.034 14.4191C131.487 17.5391 133.783 19.9125 137.439 19.9125H140.642V15.3791H139.026C137.921 15.3791 137.496 14.9258 137.326 14.4191C137.212 14.0725 137.212 13.6991 137.212 13.4058V11.3258H140.642V6.7658H137.212Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M149.871 15.3791H142.474V19.9125H152.025C154.661 19.9125 157.099 18.2058 157.099 15.8058C157.099 12.6591 152.025 12.4725 149.645 12.1791C148.851 12.0725 148.823 11.3258 149.673 11.3258H157.099V6.7658H147.519C144.883 6.7658 142.474 8.49913 142.474 10.8991C142.474 14.0458 147.519 14.2325 149.9 14.5258C150.693 14.6325 150.722 15.3791 149.871 15.3791Z",
      fill: "white"
    }
  )
);

export { HousebetsLogoIcon };
//# sourceMappingURL=HousebetsLogoIcon.js.map
